/** Props for {@link PlusIcon}. */
interface PlusIconProps {
  /** Icon width (default `0.6875rem`). */
  width?: string;
  /** Icon height (default `0.6875rem`). */
  height?: string;
  /** Stroke colour for the plus (default `#0056D6`). */
  color?: string;
}

/**
 * Plain plus icon, used inside the "Override to Met" action button.
 *
 * @param props - Optional size and stroke colour overrides
 * @returns The rendered plus SVG
 */
export function PlusIcon(props: PlusIconProps) {
  const size = {
    width: props.width || "0.6875rem",
    height: props.height || "0.6875rem",
  };
  const stroke = props.color || "#0056D6";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size.width}
      height={size.height}
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        d="M5.5 1V10M1 5.5H10"
        stroke={stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
}
